import { createRef, h } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import './styles.less';

export default ({
  parentElement,
  children,
  isVisible,
  resetVisibility,
  position,
  rootElement = useRef(window)
}) => {
  const [classes, setClasses] = useState('qs-tooltip');
  const [style, setStyle] = useState({});
  const tooltipRef = createRef();

  useEffect(() => {
    try {
      const tooltipPos = tooltipRef.current.getBoundingClientRect();
      const parentElementPos = parentElement.current.getBoundingClientRect();
      const { innerHeight, innerWidth } = rootElement.current;
      const PADDING = 20;

      const availableHeight = innerHeight - 2 * PADDING;
      const availableWidth = innerWidth - 2 * PADDING;

      const newStyle = {
        maxHeight: availableHeight,
        maxWidth: availableWidth
      };

      const tooltipPaddingFull = window
        .getComputedStyle(tooltipRef.current)
        .getPropertyValue('paddingLeft');
      const parentElementMarginString = window
        .getComputedStyle(parentElement.current)
        .getPropertyValue('margin');

      const tooltipPaddingConverted = Number(
        tooltipPaddingFull.substring(0, tooltipPaddingFull.length - 2)
      );
      const tooltipPadding = isNaN(tooltipPaddingConverted) ? 0 : tooltipPaddingConverted;
      const parentElementMarginConverted = Number(
        parentElementMarginString.substring(0, parentElementMarginString.length - 2)
      );
      const parentElementMargin = isNaN(parentElementMarginConverted)
        ? 0
        : parentElementMarginConverted;

      if (position) {
        if (position.toLowerCase() === 'top') {
          newStyle.top = `${parentElementPos.y - tooltipPos.height - 10}px`;
          newStyle.left = `${parentElementPos.x - tooltipPadding - parentElementPos.width / 2}px`;
        } else if (position.toLowerCase() === 'left') {
          newStyle.top = `${
            +parentElementPos.y + +tooltipPadding / 2 - parentElementPos.height / 2
          }px`;
          newStyle.left = `${parentElementPos.x - tooltipPos.width - 10}px`;
        } else if (position.toLowerCase() === 'right') {
          setStyle({
            top: `${+parentElementPos.y + +tooltipPadding / 2 - parentElementPos.height / 2}px`,
            left: `${+parentElementPos.x + +parentElementPos.width + 10}px`
          });
        } else {
          // default bottom
          setStyle({
            top: `${parentElementPos.y + parentElementPos.height + 10}px`,
            left: `${parentElementPos.x - tooltipPadding / 2 - parentElementPos.width / 2}px`
          });
        }
      } else {
        // default bottom position
        const { width: tooltipWidth, height: tooltipHeight } = tooltipPos;

        let top = parentElementPos.y + parentElementPos.height + parentElementMargin;
        let left = parentElementPos.x - tooltipPadding / 2;

        const horizontalSpace = availableWidth - (left + tooltipWidth);
        if (horizontalSpace < 0) {
          left += horizontalSpace; // reducing the space overflowing to right;

          if (left < 1) {
            left = PADDING;
          }
        }

        const verticalSpace = availableHeight - (top + tooltipHeight);
        if (verticalSpace < 0) {
          top += verticalSpace; // reducing the space overflowing to bottom;

          if (top < 1) {
            top = PADDING;
          }
        }

        setStyle({
          ...newStyle,
          minWidth: parentElementPos.width,
          left,
          top
        });
      }
    } catch (error) {
      // Do nothing
    }
  }, [classes, children]);

  useEffect(() => {
    setClasses(`qs-tooltip${isVisible ? ' show' : ''}`);
    if (isVisible) {
      resetVisibility();
    }
  }, [isVisible]);

  return (
    <div ref={tooltipRef} className={classes} style={style}>
      {children}
    </div>
  );
};
